"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { ContentText } from '../ContentText/ContentText.web.js';
import { ChipWrapper } from './styles.js';
import { Box } from '../Box/Box.web.js';
import { ThemeProvider } from 'styled-components';
import { IconCheck } from '../icons/ui_control/IconCheck.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { spacing } from '../constants/spacing.js';
import { styles } from '../constants/styles.js';
import { renderComponentOrElement } from '../utils/helpers/component.js';

var _excluded = ["active", "disabled", "color", "label", "onClick", "value", "multiSelect", "rightIcon", "activeIcon", "inactiveIcon", "cursor"];
var Chip = function Chip(_ref) {
  var _ref$active = _ref.active,
    active = _ref$active === undefined ? false : _ref$active,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === undefined ? false : _ref$disabled,
    colorProp = _ref.color,
    label = _ref.label,
    onClick = _ref.onClick,
    value = _ref.value,
    multiSelect = _ref.multiSelect,
    rightIcon = _ref.rightIcon,
    activeIcon = _ref.activeIcon,
    inactiveIcon = _ref.inactiveIcon,
    cursor = _ref.cursor,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleClick = React.useCallback(function () {
    return onClick === null || onClick === undefined ? undefined : onClick(value);
  }, [onClick, value]);
  var theme = useTheme();
  var chipsThemeWeb = theme.chips.web;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ChipWrapper, _extends({
    $active: active,
    $color: colorProp || theme.chips.web.color,
    onClick: handleClick,
    cursor: cursor,
    disabled: disabled
  }, props), (multiSelect || activeIcon || inactiveIcon) && /*#__PURE__*/React.createElement(Box, {
    mr: active || inactiveIcon ? spacing.xxxs : 0,
    maxWidth: active || inactiveIcon ? spacing.xs : 0,
    overflow: "hidden",
    transition: "max-width ".concat(styles.transition.timing.slowest, ", margin-right ").concat(styles.transition.timing.slowest),
    display: "inline-flex",
    alignItems: "center"
  }, active ? renderComponentOrElement(activeIcon !== null && activeIcon !== undefined ? activeIcon : /*#__PURE__*/React.createElement(IconCheck, null), {
    size: spacing.xs,
    color: chipsThemeWeb.background
  }) : inactiveIcon && renderComponentOrElement(inactiveIcon, {
    size: spacing.xs,
    color: chipsThemeWeb.inactive.text
  })), /*#__PURE__*/React.createElement(ContentText, {
    weight: "light",
    color: disabled ? chipsThemeWeb.disabled.text : active ? chipsThemeWeb.active.text : chipsThemeWeb.text,
    transition: "color ".concat(styles.transition.timing.slowest),
    transitionTimingFunction: styles.transition["function"].base
  }, label), rightIcon && renderComponentOrElement(rightIcon, {
    style: {
      color: chipsThemeWeb.background,
      marginLeft: spacing.xxxs,
      marginRight: "-".concat(spacing.xxxs)
    }
  })));
};

export { Chip };
